// Review Types and Interfaces

export enum reviewType {
  CATALOG_PRODUCT = 'CatalogProduct',
  PRODUCT = 'Product',
  FOOD = 'foodproducts',
}

export interface Review {
  revRatingNo: string;
  rating: number;
  status: "Published" | "Unpublished" | "Hold" | "Rejected";
  description?: string;
  images: string[];
  videos: string[];
  productId: string;
  reviewType: reviewType;
  customerId: string;
  customerName?: string;
  customerEmail?: string;
  customerAvatar?: string;
  productCreatorId: string;
  productCreatedBy: string;
  purchasedVariationSnapshot?: Record<string, any>;
  isVerifiedPurchase?: boolean;
  avatar?: string;
  createdAt: Date;
  updatedAt?: Date;
  isDeleted: boolean;
  _id?: string;
}

export interface CreateReviewDto {
  rating: number;
  description?: string;
  images?: string[];
  videos?: string[];
  productId: string;
  reviewType: reviewType | string;
  customerName?: string;
  customerEmail?: string;
  customerAvatar?: string;
}

export interface CreateReviewWithMediaDto {
  rating: number;
  description?: string;
  productId: string;
  images?: string[];
  videos?: string[];
  reviewType: reviewType | string;
  productVariantId?: string;
  sellerSkuId?: string;
  purchasedVariationSnapshot?: Record<string, any>;
  isVerifiedPurchase?: boolean;
  status?: string;
  customerName?: string;
  customerEmail?: string;
  customerAvatar?: string;
}

export interface UpdateReviewWithMediaDto {
  reviewId?: string;
  rating?: number;
  description?: string;
  images?: string[];
  videos?: string[];
  customerName?: string;
  customerAvatar?: string;
  status?: string;
}

export interface MyReviewResponse {
  review: Review | null;
  canEdit: boolean;
  daysLeft: number;
  deadline?: string;
}

export interface UpdateReviewStatusDto {
  status: "Published" | "Unpublished" | "Hold" | "Rejected";
}

export interface ReviewFilterDto {
  status?: "Published" | "Unpublished" | "Hold" | "Rejected";
  productId?: string;
  customerId?: string;
  productCreatorId?: string;
  search?: string;
}

export interface ReviewQueryDto extends ReviewFilterDto {
  page?: number;
  limit?: number;
}

export interface PaginationMeta {
  page: number;
  limit: number;
  total: number;
  pages: number;
}

export interface ReviewsResponse {
  reviews: Review[];
  pagination: PaginationMeta;
}

export interface RatingPercentage {
  star: number;
  count: number;
  percentage: number;
}

export interface ProductRating {
  productId: string;
  averageRating: number;
  totalReviews: number;
}

export interface ProductReviewPercentage {
  productId: string;
  totalReviews: number;
  averageRating: number;
  ratingDistribution: RatingPercentage[];
}

export interface ReviewState {
  reviews: Review[];
  currentReview: Review | null;
  myReview: Review | null;
  canEditMyReview: boolean;
  editDaysLeft: number;
  productReviews: Review[];
  productRating: ProductRating | null;
  productReviewPercentage: ProductReviewPercentage | null;
  pagination: PaginationMeta | null;
  isLoading: boolean;
  isCreating: boolean;
  isUpdating: boolean;
  error: string | null;
}
